// extracted by mini-css-extract-plugin
module.exports = {"root":"CellText_root__jC_0_"};